import { render } from "./ConversationView.vue?vue&type=template&id=66a0c2dc&scoped=true"
import script from "./ConversationView.vue?vue&type=script&lang=js"
export * from "./ConversationView.vue?vue&type=script&lang=js"

import "./ConversationView.vue?vue&type=style&index=0&id=66a0c2dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a0c2dc"]])

export default __exports__